import {
    ICadastraEEditaHorarioDisponivelHorario,
    ICompromissoDisponivelVistoria,
    IListarCompromissoDisponivelHorario,
    IUsuarioDisponivelHorario,
} from "../../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarCompromissoDisponivelHorarioService(
    data: string,
    idEmpreendimento: number,
    idUsuario?: number,
    idCaso?: number,
    flTelaAgendamento?: boolean
) {
    return Service(
        Axios.get<Array<IListarCompromissoDisponivelHorario>>(
            `/home/compromissodisponivelvistoriahorarios/listarcompromissodisponivelvistoriahorarios?data=${data}&idEmpreendimento=${idEmpreendimento}&idUsuario=${
                idUsuario ?? 0
            }${idCaso ? `&idCaso=${idCaso}` : ""}${idCaso ? `&fl_telaAgendamento=${flTelaAgendamento}` : ""}`
        )
    );
}

export async function ListarCompromissoDisponivelHorarioDisponiveisService(
    data: string,
    idEmpreendimento: number,
    idUsuario?: number,
    idCaso?: number
) {
    return Service(
        Axios.get<Array<IListarCompromissoDisponivelHorario>>(
            `/home/compromissodisponivelvistoriahorarios/listarcompromissodisponivelvistoriahorariosdisponiveis?data=${data}&idEmpreendimento=${idEmpreendimento}&idUsuario=${
                idUsuario ?? 0
            }${idCaso ? `&idCaso=${idCaso}` : ""}`
        )
    );
}

export async function ListarCompromissoDisponivelVistoriaService(
    idProduto: number,
    date: string
) {
    return Service(
        Axios.get<Array<ICompromissoDisponivelVistoria>>(
            `/home/compromissodisponivelvistoria/listacompromissodisponivelvistoria?idEmpreendimento=${idProduto}&data=${date}`
        )
    );
}

export async function CadastrarCompromissoDisponivelVistoriaService(
    requestBody: ICompromissoDisponivelVistoria
) {
    return Service(
        Axios.post(
            `/home/compromissodisponivelvistoria/cadastrarcompromissodisponivelvistoria`,
            requestBody
        )
    );
}

export async function ListarUsuariosCompromissoDisponivelHorariosService(
    data: string,
    idEmpreendimento: number
) {
    return Service(
        Axios.get<Array<IUsuarioDisponivelHorario>>(
            `/home/compromissodisponivelvistoriahorarios/listarusuarioscompromissodisponivelvistoriahorarios?data=${data}&idEmpreendimento=${idEmpreendimento}`
        )
    );
}

export async function TransfereCompromissoService(
    ID_TIPO_COMPROMISSO: number,
    ID_USUARIO_REMETENTE: number,
    ID_USUARIO_DESTINATARIO: number
) {
    return Service(
        Axios.post<Array<IUsuarioDisponivelHorario>>(
            `/home/transferecompromisso/transferecompromissoemmassa?ID_TIPO_COMPROMISSO=${ID_TIPO_COMPROMISSO}&ID_USUARIO_REMETENTE=${ID_USUARIO_REMETENTE}&ID_USUARIO_DESTINATARIO=${ID_USUARIO_DESTINATARIO}`
        )
    );
}

export async function ListarHorariosDisponiveisService(
    data?: string,
    idEmpreendimento?: number,
    idUsuario?: number
) {
    return Service(
        Axios.get<Array<IListarCompromissoDisponivelHorario>>(
            `/home/compromissodisponivelvistoriahorarios/listarcompromissodisponivelvistoriahorarios${
                data && idEmpreendimento && idUsuario
                    ? `?data=${data}&idEmpreendimento=${idEmpreendimento}&idUsuario=${idUsuario}`
                    : ""
            }`
        )
    );
}

export async function CadastrarHorariosDisponiveisService(
    requestBody: ICadastraEEditaHorarioDisponivelHorario
) {
    return Service(
        Axios.post(
            `/home/compromissodisponivelvistoriahorarios/cadastrarcompromissodisponivelvistoriahorarios`,
            requestBody
        )
    );
}

export async function EditarHorariosDisponiveisService(
    requestBody: ICadastraEEditaHorarioDisponivelHorario
) {
    return Service(
        Axios.put(
            `/home/compromissodisponivelvistoriahorarios/atualizarcompromissodisponivelvistoriahorarios`,
            requestBody
        )
    );
}

export async function DeletarHorariosDisponiveisService(
    idCompromissoHorario: number
) {
    return Service(
        Axios.delete(
            `/home/compromissodisponivelvistoriahorarios/deletarcompromissodisponivelvistoriahorarios?idCompromissoVistoriaHorario=${idCompromissoHorario}`
        )
    );
}
